export default class Globals {
	static getBaseUrl() {
		try {
			TheApp
		} catch (e) {
			return "/"
		}
		return TheApp.Env.BaseUrl;
	}
	static getBaseUrlNls() {
		try {
			TheApp
		} catch (e) {
			return "/"
		}
		return TheApp.Env.BaseUrlNls;
	}
}

Globals.API_KEY = "WEB.0.0";

// Mostra nella console i dati di tracking 
Globals.SHOW_TRACKING_DATA = false;

// Mostra nella console le chiamate del service manager
Globals.SERVICE_MANAGER_SHOW_CALLS = false;

// Esclude totalmente il processo fake
try {
	Globals.SERVICE_MANAGER_USE_FAKE = true && (TheApp.Env.globalKeySet == "dev");
} catch (error) {
	console.log(error);
}